module.exports = __webpack_public_path__ + "img/pinfl__ko__passport.558e1fcb.png";